import type { HeaderV2Link } from "../sections/HeaderV2/types";
import { clamp } from "./clamp";

export enum MegaMenuStatus {
  LOADING = "loading",
  READY = "ready",
  ERROR = "error",
}

export const MEGA_MENU_MAX_ITEMS = 30;

export const MEGA_MENU_DEFAULT_MAX_ITEMS = 12;

export type MegaMenuSource = { linkId: string; contentTypeId: string };

export const resolveMegaMenuSource = ({ link }: { link: HeaderV2Link }): MegaMenuSource | null => {
  const megaMenu = link.megaMenu;
  if (link.isActive === false || link.id == null) return null;
  if (!megaMenu?.enabled || !megaMenu.contentTypeId || !megaMenu.moduleSlug) return null;
  return { linkId: String(link.id), contentTypeId: megaMenu.contentTypeId };
};

export const clampMegaMenuMaxItems = ({ value }: { value?: number }) => {
  const parsed = Math.round(Number(value));
  if (parsed === 0) return MEGA_MENU_MAX_ITEMS;
  return clamp({
    value: Number.isFinite(parsed) && parsed ? parsed : MEGA_MENU_DEFAULT_MAX_ITEMS,
    min: 1,
    max: MEGA_MENU_MAX_ITEMS,
  });
};
